import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '../Basic/Select';

class CountryRegions extends React.Component {
    render() {
        const countries = window.osa.countryLookup;
        if (!countries) return null;
        const p = this.props;
        const countryModel = countries.map((c) => ({ id: c.code, name: c.name }));
        const countryRegions = countries.find((x) => x.code == p.selectedCountry);
        let regionModel = [];
        if (countryRegions)
            regionModel = countryRegions.regions.map(((r) => ({ id: r.code, name: r.name })));
        return (
            <div className="row">
                <div className="col-sm-6 col-md-6">
                    <Select id={p.name + '_country'} name={p.name + '_country'} default="CA"
                        title="Country" items={countryModel} isControl disabled={p.disabled} required />
                </div>
                <div className="col-sm-6 col-md-6">
                    <Select id={p.name + '_state'} name={p.name + '_state'} default="BC"
                        title="Province/state" items={regionModel} isControl disabled={p.disabled} required />
                </div>
            </div>
        );
    }
}

CountryRegions.propTypes = {
    name: PropTypes.string,
    selectedCountry: PropTypes.string,
    disabled: PropTypes.bool
};

const mapStateToProps = (state, props) => {
    return {
        selectedCountry: state.form[props.name + '_country'],
        selectedRegions: state.form[props.name + '_state']
    };
};

export default connect(mapStateToProps)(CountryRegions);